module.exports = __webpack_public_path__ + "media/assets/StartArrow-35f9413159c1df54a9fd19f91285affc.svg";